import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ErrorResponse } from '@models/error';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

interface Params {
    orderNo: string;
}

declare module '@stackflow/config' {
    interface Register {
        CancelChargeModal: Params;
    }
}

const CancelChargeModal: ActivityComponentType<'CancelChargeModal'> = ({ params }) => {
    const { orderNo } = params;
    const { t } = useTranslation('prepaidCard');
    const { pop } = useFlow();
    const queryClient = useQueryClient();
    const { mutate, isPending } = useMutation({
        mutationFn: () => PrepaidCardApi.cancelPrepaidCardOrder(orderNo),
        async onSuccess() {
            pop();
            await queryClient.invalidateQueries({ queryKey: userPrepaidCardQueries._def });
            toast.success(t('log.cancelCharge.success'));
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('log.cancelCharge.error'));
        },
    });

    return (
        <AppModal title={t('log.cancelCharge.title')}
            deny={t('log.cancelCharge.close')}
            confirm={t('log.cancelCharge.confirm')}
            onConfirm={() => mutate()}
            confirmDisabled={isPending}
            denyDisabled={isPending}
            disableOutside={isPending} >
            <Text size='title' align='center' multiline>
                {t('log.cancelCharge.description')}
            </Text>
        </AppModal>
    );
};

export default CancelChargeModal;
